var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"timeline-anchor",attrs:{"id":'timeline-section-' + _vm.item.blockId}})}
var staticRenderFns = []

export { render, staticRenderFns }